<div class="wrapper">
  <app-page-info
    [resourceName]="resourceName"
    [loginAndRoles]="loginAndRoles"
  />
  @if (currentResourceParams) {
    <app-records-table-container
      class="app-records-table-container"
      [resourceParams]="currentResourceParams"
    />
  }
</div>
